import styled from "styled-components"

export const Container = styled.div`
    color: var(--lightGrey);
    margin-top: 20px;
    padding: 20px;
    font-size: var(--fontM);
`

export const ProductDetail = styled.div`
    display: flex;  
`

export const Image = styled.img`
    height: 100%;
    width: 100%;
    border-radius: 20px;
    object-fit: cover;
    z-index: 2;
`

export const Details = styled.div`
    width: 200px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: var(--lightGrey);
    font-size: var(--fontS);    
`

export const ProductInfo = styled.span`
`

export const ImageContainer = styled.div`
    width: 150px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 10px 0px;

`
